export interface GeneralConsultState {
  patient: number;
  saving: boolean;
  totalSaved: number;
  save: boolean;
}

export const generalConsultIS: GeneralConsultState = {
  patient: -1,
  saving: false,
  totalSaved: 0,
  save: false,
};
